import { icons } from 'src/assets/iconDef/icon.def';

export const otMenuDef = [
    {
        name: 'menu.operation_theatre',
        icon: 'fa fa-calendar',
        data: {
            nav_url: "ot_m"
        },
        children: [
            {
                "name": "menu.ot_scheduling",
                "resource": "schedule_event_ot",
                "icon": "fa fa-superpowers",
                "url": "schedule_event_ot",
                "auto_crud": true,
                "breadcrumb": "OT Schedular"
            },
            {
                "name": "menu.ot_user_mapping",
                "resource": "ot_user_mapping",
                "icon": "fa fa-superpowers",
                "url": "ot_user_mapping",
                "auto_crud": true,
                "breadcrumb": "OT User Mapping"
            },
            {
                name: 'menu.ot_patient_list',
                resource: 'ot_format',
                icon: 'fa fa-plus-square',
                url: 'ot_format',
                auto_crud: true,
                breadcrumb: 'OT',
                check_permission: false
            }, {
                "name": "OT Encounter Transfer",
                "resource": "ot_encounter_transfer",
                "icon": "fa fa-user-md",
                "url": "ot_encounter_transfer",
                "auto_crud": true,
                "showMenu": false
            },
            {
                "name": "POST OP TO ADT",
                "resource": "post_op_to_adt",
                "icon": "fa fa-user-md",
                "url": "post_op_to_adt",
                "auto_crud": true,
                "showMenu": false
            },
            {
                "name": "ot_completed_surgery_list",
                "resource": "ot_completed_surgery_list",
                "icon": "fa fa-user-md",
                "url": "ot_completed_surgery_list",
                "auto_crud": true,
                "showMenu": false
            },
            {
                "name": "ot_cancelled_surgery_list",
                "resource": "ot_cancelled_surgery_list",
                "icon": "fa fa-user-md",
                "url": "ot_cancelled_surgery_list",
                "auto_crud": true,
                "showMenu": false
            },
            {
                "name": "cathlab_cancelled_surgery_list",
                "resource": "cathlab_cancelled_surgery_list",
                "icon": "fa fa-user-md",
                "url": "cathlab_cancelled_surgery_list",
                "auto_crud": true,
                "showMenu": false
            },
            {
                "name": "cathlab_completed_surgery_list",
                "resource": "cathlab_completed_surgery_list",
                "icon": "fa fa-user-md",
                "url": "cathlab_completed_surgery_list",
                "auto_crud": true,
                "showMenu": false
            },
            {
                "name": "Surgery Request",
                "resource": "surgery_request",
                "icon": "fa fa-user-md",
                "url": "surgery_request",
                "auto_crud": true,
                "showMenu": false
            },
            {
                "name": 'menu.ip_admission',
                "resource": 'surgery_request_ot_cath',
                "icon": 'fa fa-plus-square',
                "url": 'surgery_request_ot_cath',
                "auto_crud": true,
                "breadcrumb": 'Admission',
                "showMenu": false
            },
            {
                "name": "Surgery Request",
                "resource": "surgery_request_op",
                "icon": "fa fa-user-md",
                "url": "surgery_request_op",
                "auto_crud": true,
                "showMenu": false
            },
            {
                "name": "Surgery Request",
                "resource": "surgery_request_op_new",
                "icon": "fa fa-user-md",
                "url": "surgery_request_op_new",
                "auto_crud": true,
                "showMenu": false
            },
              {
                "name": "Surgery Request",
                "resource": "cathlab_surgery_request_op_new",
                "icon": "fa fa-user-md",
                "url": "cathlab_surgery_request_op_new",
                "auto_crud": true,
                "showMenu": false
            },
            {
                "name": "Surgery Request",
                "resource": "surgery_reuest_op_emr",
                "icon": "fa fa-user-md",
                "url": "surgery_reuest_op_emr",
                "auto_crud": true,
                "showMenu": false
            },
            {
                "name": "Surgery Request",
                "resource": "cathlab_surgery_request_op_emr",
                "icon": "fa fa-user-md",
                "url": "cathlab_surgery_request_op_emr",
                "auto_crud": true,
                "showMenu": false,
                "check_permission": false
            },
            {
                "name": "Package Request",
                "resource": "package_request",
                "icon": "fa fa-user-md",
                "url": "package_request",
                "auto_crud": true,
                "showMenu": false
            },
            {
                "name": "Package Request Update",
                "resource": "package_request_update",
                "icon": "fa fa-user-md",
                "url": "package_request_update",
                "auto_crud": true,
                "showMenu": false
            },
            {
                "name": "Surgery Request",
                "resource": "surgery_request_update",
                "icon": "fa fa-user-md",
                "url": "surgery_request_update",
                "auto_crud": true,
                "showMenu": false
            },
            {
                "name": "Surgery Request",
                "resource": "cathlab_surgery_request_update",
                "icon": "fa fa-user-md",
                "url": "cathlab_surgery_request_update",
                "auto_crud": true,
                "showMenu": false
            },
            {
                name: "menu.ot_worklist",
                resource: "ot_worklist",
                icon: 'fa fa-plus-square',
                url: "ot_worklist",
                auto_crud: true,
                breadcrumb: 'OT',
                check_permission: false
            },
            {
                name: 'menu.transfer_request',
                resource: 'ot_transfer',
                icon: 'fa fa-h-square',
                url: 'ot_transfer',
                breadcrumb: 'Transfer Request',
                auto_crud: true
            },
            {
                "name": "Surgery Request",
                "resource": "ot_ip_patient_list",
                "icon": "fa fa-user-md",
                "url": "ot_ip_patient_list",
                "auto_crud": true,
                "showMenu": false
            },
            {
                "name": "OT Surgery Scheduling",
                "resource": "ot_surgery_scheduling",
                "icon": "fa fa-user-md",
                "url": "ot_surgery_scheduling",
                "auto_crud": true,
                "showMenu": false
            },
            {
                "name": "Surgery Details",
                "resource": "ot_surgery_details",
                "icon": "fa fa-user-md",
                "url": "ot_surgery_details",
                "auto_crud": true,
                "showMenu": false
            },
            {
                "name": "register_patient",
                "resource": "patient",
                "icon": "fa fa-user-md",
                "url": "patient",
                "auto_crud": true,
                "showMenu": false
            },

            {
                "name": "Package Details",
                "resource": "ot_package_details",
                "icon": "fa fa-user-md",
                "url": "ot_package_details",
                "auto_crud": true,
                "showMenu": false
            },
            {
                "name": "Package Details",
                "resource": "cathlab_package_details",
                "icon": "fa fa-user-md",
                "url": "cathlab_package_details",
                "auto_crud": true,
                "showMenu": false
            },
            {
                "name": "Surgery Request",
                "resource": "surgery_request_admitted",
                "icon": "fa fa-user-md",
                "url": "surgery_request_admitted",
                "auto_crud": true,
                "showMenu": false
            },
            {
                "name": "Pre-OP Patients",
                "resource": "ot_pre_op_patient_list",
                "icon": "fa fa-user-md",
                "url": "ot_pre_op_patient_list",
                "auto_crud": true,
                "showMenu": false
            },
            {
                "name": "Post-OP Patients",
                "resource": "ot_post_op_patient_list",
                "icon": "fa fa-user-md",
                "url": "ot_post_op_patient_list",
                "auto_crud": true,
                "showMenu": false
            },
            {
                "name": "Checkin",
                "resource": "ot_pre_op_checklist",
                "icon": "fa fa-user-md",
                "url": "ot_pre_op_checklist",
                "auto_crud": true,
                "showMenu": false
            },
            {
                "name": "Checkin",
                "resource": "view_ot_pre_op_checklist",
                "icon": "fa fa-user-md",
                "url": "view_ot_pre_op_checklist",
                "auto_crud": true,
                "showMenu": false
            },
            {
                "name": "Post Op Cheklist",
                "resource": "ot_post_op_checklist",
                "icon": "fa fa-user-md",
                "url": "ot_post_op_checklist",
                "auto_crud": true,
                "showMenu": false
            },
            {
                "name": "View Post Op Cheklist",
                "resource": "view_ot_post_op_checklist",
                "icon": "fa fa-user-md",
                "url": "view_ot_post_op_checklist",
                "auto_crud": true,
                "showMenu": false
            },
            {
                "name": "OT Checkin",
                "resource": "preop_ot_transfer",
                "icon": "fa fa-user-md",
                "url": "preop_ot_transfer",
                "auto_crud": true,
                "showMenu": false
            },
            {
                "name": "Clearance",
                "resource": "ot_cathlab_finance",
                "icon": "fa fa-user-md",
                "url": "ot_cathlab_finance",
                "auto_crud": true,
                "showMenu": false
            },
            {
                "name": "menu.surgery_rule",
                "icon": "fa fa-building-o",
                "resource": "surgery_rule",
                "url": "surgery_rule",
                "auto_crud": true,
                "check_permission": true,
                "breadcrumb": "surgery_rule"
              },
            {
                "name": "Clearance",
                "resource": "ot_cathlab_finance_common",
                "icon": "fa fa-user-md",
                "url": "ot_cathlab_finance_common",
                "auto_crud": true,
                "check_permission": false,
                "showMenu": false
            },
            {
                "name": "OT Checkout",
                "resource": "ot_postop_transfer",
                "icon": "fa fa-user-md",
                "url": "ot_postop_transfer",
                "auto_crud": true,
                "showMenu": false
            },
            {
                "name": "OT Checkout",
                "resource": "ot_clearance",
                "icon": "fa fa-user-md",
                "url": "ot_clearance",
                "auto_crud": true,
                "showMenu": false
            },
            {
                "name": "Pre-OP Patient Template",
                "resource": "ot_pre_op_patient_template",
                "icon": "fa fa-user-md",
                "url": "ot_pre_op_patient_template",
                "auto_crud": true,
                "showMenu": false
            },
            {
                "name": "Checkin/Checkout Patient Template",
                "resource": "ot_checkin_checkout_patient_template",
                "icon": "fa fa-user-md",
                "url": "ot_checkin_checkout_patient_template",
                "auto_crud": true,
                "showMenu": false
            },
            {
                "name": "Post-OP Patient Template",
                "resource": "ot_post_op_patient_template",
                "icon": "fa fa-user-md",
                "url": "ot_post_op_patient_template",
                "auto_crud": true,
                "showMenu": false
            },
            {
                "name": "cathlab_tracker",
                "resource": "cathlab_tracker",
                "icon": "fa fa-user-md",
                "url": "cathlab_tracker",
                "auto_crud": true,
                "showMenu": false
            }
        ]
    },
    {
        name: 'menu.cathlab',
        icon: 'fa fa-calendar',
        data: {
            nav_url: "cathlab_m"
        },
        children: [
            {
                "name": "menu.cathlab_scheduling",
                "resource": "schedule_event_cathlab",
                "icon": "fa fa-superpowers",
                "url": "schedule_event_cathlab",
                "auto_crud": true,
                "breadcrumb": "CathLab Schedular"
            },
            {
                "name": "menu.cathlab_user_mapping",
                "resource": "cathlab_user_mapping",
                "icon": "fa fa-superpowers",
                "url": "cathlab_user_mapping",
                "auto_crud": true,
                "breadcrumb": "CathLab User Mapping"
            },
            {
                "name": "menu.cathlab_patient_list",
                "resource": "cathlab_format",
                "icon": "fa fa-plus-square",
                "url": "cathlab_format",
                "auto_crud": true,
                "breadcrumb": "CathLab",
                "check_permission": false
            },
            {
                "name": "menu.cathlab_worklist",
                "resource": "cathlab_worklist",
                "icon": "fa fa-plus-square",
                "url": "cathlab_worklist",
                "auto_crud": true,
                "breadcrumb": "CathLab",
                "check_permission": false
            },
            {
                "name": "menu.cathlab_transfer_request",
                "resource": "cathlab_transfer",
                "icon": "fa fa-h-square",
                "url": "cathlab_transfer",
                "breadcrumb": "CathLab Transfer Request",
                "auto_crud": true
            },

            {
                "name": "Surgery Request",
                "resource": "cathlab_ip_patient_list",
                "icon": "fa fa-user-md",
                "url": "cathlab_ip_patient_list",
                "auto_crud": true,
                "showMenu": false
            },
            {
                "name": "CathLab Surgery Scheduling",
                "resource": "cathlab_surgery_scheduling",
                "icon": "fa fa-user-md",
                "url": "cathlab_surgery_scheduling",
                "auto_crud": true,
                "showMenu": false
            },
            {
                "name": "Surgery Details",
                "resource": "cathlab_surgery_details",
                "icon": "fa fa-user-md",
                "url": "cathlab_surgery_details",
                "auto_crud": true,
                "showMenu": false
            },
            {
                "name": "Package Request Update",
                "resource": "cathlab_package_request",
                "icon": "fa fa-user-md",
                "url": "cathlab_package_request",
                "auto_crud": true,
                "showMenu": false
            },{
                "name": "Package Request Update",
                "resource": "cathlab_package_request_update",
                "icon": "fa fa-user-md",
                "url": "cathlab_package_request_update",
                "auto_crud": true,
                "showMenu": false
            },
            {
                "name": "Pre-CathLab Patients",
                "resource": "cathlab_pre_patient_list",
                "icon": "fa fa-user-md",
                "url": "cathlab_pre_patient_list",
                "auto_crud": true,
                "showMenu": false
            },
            {
                "name": "Post-CathLab Patients",
                "resource": "cathlab_post_patient_list",
                "icon": "fa fa-user-md",
                "url": "cathlab_post_patient_list",
                "auto_crud": true,
                "showMenu": false
            },
            {
                "name": "Checkin",
                "resource": "cathlab_pre_checklist",
                "icon": "fa fa-user-md",
                "url": "cathlab_pre_checklist",
                "auto_crud": true,
                "showMenu": false
            },
            {
                "name": "Checkin",
                "resource": "view_cathlab_pre_checklist",
                "icon": "fa fa-user-md",
                "url": "view_cathlab_pre_checklist",
                "auto_crud": true,
                "showMenu": false
            },
            {
                "name": "Surgery Request",
                "resource": "cathlab_surgery_request",
                "icon": "fa fa-user-md",
                "url": "cathlab_surgery_request",
                "auto_crud": true,
                "showMenu": false
            },
            {
                "name": "Surgery Request",
                "resource": "cathlab_surgery_request_op",
                "icon": "fa fa-user-md",
                "url": "cathlab_surgery_request_op",
                "auto_crud": true,
                "showMenu": false
            },
            {
                "name": "Surgery Request",
                "resource": "cathlab_surgery_request_admitted",
                "icon": "fa fa-user-md",
                "url": "cathlab_surgery_request_admitted",
                "auto_crud": true,
                "showMenu": false
            },
            {
                "name": "CathLab Checkin",
                "resource": "preop_cathlab_transfer",
                "icon": "fa fa-user-md",
                "url": "preop_cathlab_transfer",
                "auto_crud": true,
                "showMenu": false
            },
            {
                "name": "CathLab Checkout",
                "resource": "cathlab_postop_transfer",
                "icon": "fa fa-user-md",
                "url": "cathlab_postop_transfer",
                "auto_crud": true,
                "showMenu": false
            },
            {
                "name": "menu.clearance_status",
                "icon": "fa fa-h-square",
                "url": "clearance_status_ot",
                "auto_crud": false,
                "showMenu": true
            },
            {
                "name": "menu.clearance_status",
                "icon": "fa fa-h-square",
                "url": "clearance_status_cathlab",
                "auto_crud": false,
                "showMenu": true
            },
            {
                "name": "OT Checkout",
                "resource": "ot_clearance",
                "icon": "fa fa-user-md",
                "url": "ot_clearance",
                "auto_crud": true,
                "showMenu": false
            },
            {
                "name": "OT Checkout",
                "resource": "cathlab_clearance",
                "icon": "fa fa-user-md",
                "url": "cathlab_clearance",
                "auto_crud": true,
                "showMenu": false
            },

            {
                "name": "menu.ot_formate_side",
                "resource": "ot_formate_side",
                "icon": "fa fa-plus-square",
                "url": "ot_formate_side",
                "auto_crud": true,
                "breadcrumb": "OT",
                "showMenu": false,
                "check_permission": false
            },
            {
                "name": "menu.ot_advice_medication_order",
                "resource": "ot_advice_medication_order",
                "icon": "fa fa-plus-square",
                "url": "ot_advice_medication_order",
                "auto_crud": true,
                "breadcrumb": "OT",
                "showMenu": false,
                "check_permission": false
            },
            {
                "name": "menu.file_document",
                "resource": "ot_advice_medication_order",
                "icon": "fa fa-plus-square",
                "url": "file_document",
                "auto_crud": true,
                "breadcrumb": "OT",
                "showMenu": false,
                "check_permission": false
            },
            {
                "name": "menu.care_plan",
                "resource": "care_plan",
                "icon": "fa fa-plus-square",
                "url": "care_plan",
                "auto_crud": true,
                "breadcrumb": "pathology",
                "check_permission": false,
                "showMenu": false
            },
            {
                "name": "menu.care_plan",
                "resource": "ip_ward_consumable_highly",
                "icon": "fa fa-plus-square",
                "url": "ip_ward_consumable_highly",
                "auto_crud": true,
                "breadcrumb": "pathology",
                "showMenu": false,
                "check_permission": false
            },
            {
                "name": "menu.care_plan",
                "resource": "ip_ward_consumable_highly_sub_form",
                "icon": "fa fa-plus-square",
                "url": "ip_ward_consumable_highly_sub_form",
                "auto_crud": true,
                "breadcrumb": "pathology",
                "showMenu": false,
                "check_permission": false
            }
        ]
    },
    {
        name: 'menu.patient_registration',
        resource: 'pme_data_format',
        icon: 'fa fa-plus-square',
        url: 'pme_data_format',
        auto_crud: true,
        breadcrumb: 'pme_data_format',
        check_permission: false
    }
]
